module.exports = "<Snackbar\n  message=\"Event added to your calendar\"\n  action=\"undo\"\n  autoHideDuration={this.state.autoHideDuration}\n  onActionTouchTap={this._handleAction}/>\n//Somewhere in our code\n_handleAction() {\n  //We can add more code to this function, but for now we\\ll just include an alert.\n  alert(\"We removed the event from your calendar.\");\n};\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/raw-code/snackbars-code.txt
 ** module id = 853
 ** module chunks = 0
 **/